var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-entity',{attrs:{"entity":_vm.entityLocal,"loading":false},on:{"close-card":_vm.closeCard}})}
var staticRenderFns = []

export { render, staticRenderFns }